module.exports = __webpack_public_path__ + "media/images/emoticons/dog-c254b229bac11a8ddac0d7646181fbe8.gif";